import { createRouter, Navigate } from '@tanstack/react-router';
import { ErrorState } from './components/media/shared/ErrorState.js';
import { parseSearch, stringifySearch } from './lib/search-codec.js';
import { routeTree } from './routeTree.gen.js';

export const router = createRouter({
  routeTree,
  defaultErrorComponent: () => <ErrorState />,
  defaultNotFoundComponent: () => <Navigate to="/dashboard" replace />,
  parseSearch,
  stringifySearch,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
